import React from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import PropTypes from 'prop-types'

const Body = styled.div`
    white-space: pre-line;
    line-height: 1.5;

    ul, ol {
        margin-left: 1rem;
        margin-bottom: 1rem;
        padding-left: 0;
    }

    li {
        margin-bottom: 0.5rem;
        margin-left: 1rem;
        display: list-item;
        list-style-type: disc;
    }

    p {
        white-space: pre-wrap;
        margin-bottom: 0.5rem;
    }
`

const Title = styled.h2`
    margin-bottom: 1em;

    color: ${props => props.theme.colors.lightGreenText};
    text-transform: uppercase;
    font-weight: bold;
    height: 100px !important;
    cursor: pointer;
    text-align: center;
`

const ThankYouPage = styled.div`
    width: 100%;
`

class FormThankYouPage extends React.Component {

    render() {
        const { header, body } = this.props

        return (
            <ThankYouPage>
                <Title>{header}</Title>
                {body && body.thankYouPageBody &&
                    <Body>
                        <ReactMarkdown source={body.thankYouPageBody} escapeHtml={false} />
                    </Body>
                }
            </ThankYouPage>
        )
    }
}

FormThankYouPage.propTypes = {
    header: PropTypes.string,
    body: PropTypes.object,
    loadingText: PropTypes.string
}

export default FormThankYouPage
